/** @format */
import { Component, EventEmitter, inject, Output, ViewEncapsulation } from '@angular/core';
import { FudisGroupValidators } from '@funidata/ngx-fudis';
import { TranslocoService } from '@ngneat/transloco';
import { MaxLength } from 'common-typescript/constants';
import { LocalizedUrl, PayerDetails } from 'common-typescript/types';
import { EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FudisFormValidatorsService } from 'sis-components/form/fudis-form-validators.service';
import { SisFormBuilder } from 'sis-components/form/sis-form-builder.service';
import { UniversityService } from 'sis-components/service/university.service';

@Component({
    selector: 'app-study-right-extension-application-payer-details',
    templateUrl: './study-right-extension-application-payer-details.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class StudyRightExtensionApplicationPayerDetailsComponent {
    @Output() readonly continue = new EventEmitter<Readonly<PayerDetails>>();
    @Output() readonly previous = new EventEmitter<void>();

    private readonly fb = inject(SisFormBuilder);
    private readonly fudisValidators = inject(FudisFormValidatorsService);
    private readonly transloco = inject(TranslocoService);
    private readonly universityService = inject(UniversityService);

    protected readonly paymentInstructionsUrl$ = this.universityService.getCurrentUniversitySettings().pipe(
        map(settings => settings.studyRightExtensionPaymentConfiguration?.instructionsUrl),
        catchError(() => EMPTY), // No need to show an error if fetching the URL fails
    );

    protected readonly form = this.fb.group({
        firstName: ['', [this.fudisValidators.required(), this.fudisValidators.maxLength(MaxLength.MAX_SHORT_STRING_LENGTH)]],
        lastName: ['', [this.fudisValidators.required(), this.fudisValidators.maxLength(MaxLength.MAX_SHORT_STRING_LENGTH)]],
        email: ['', [this.fudisValidators.required(), this.fudisValidators.email()]],
        // Fudis requires all checkbox controls to be wrapped in a group
        terms: this.fb.group(
            { acceptTerms: [false] },
            {
                validators: FudisGroupValidators.oneRequired(
                    this.transloco.translate('PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.MUST_ACCEPT_TERMS'),
                ),
            },
        ),
    });

    onSubmit(): void {
        if (this.form.valid) {
            const { firstName, lastName, email } = this.form.value;
            this.continue.emit({ firstName, lastName, email });
        }
    }
}
